<template>
  <div class="big-screen">
    <div class="commom-container">
      <div class="screen-swiper">
        <swiper
          :modules="modules"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          :slides-per-view="1"
          navigation
          :pagination="{ clickable: true }"
        >
          <swiper-slide>
            <a href="##">
              <img src="@/assets/images/other/bigScreen-img01.png" alt />
            </a>
          </swiper-slide>
          <swiper-slide>
            <a href="##">
              <img src="@/assets/images/other/bigScreen-img01.png" alt />
            </a>
          </swiper-slide>
        </swiper>
        <div class="cover">
          <img src="@/assets/images/other/bigScreen-bg.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import { ref } from 'vue'

const onSwiper = (swiper) => {
  console.log(swiper);
};
const onSlideChange = () => {
  console.log('slide change');
};
const modules = ref([Navigation, Pagination])
</script>
<style lang="less" >
.big-screen {
  .commom-container {
    .screen-swiper {
      position: relative;
      .cover {
        position: absolute;
        width: 74%;
        left: 13%;
        top: 53px;
        z-index: 12;
      }
    }
    .swiper {
      padding: 80px 15% 280px;
      position: relative;
      margin:0;
      &:after,
      &:before {
        display: block;
        content: "";
        width: 13%;
        height: 100%;
        background: #f5f6fb;
        position: absolute;
        top: 0;
        z-index: 6;
      }
      &:after {
        right: 0;
      }
      &:before {
        left: 0;
      }
    }
    .swiper-slide {
      opacity: 0;
      &.swiper-slide-active {
        opacity: 1;
      }
    }
  }
}
</style>